import type { Locale } from "@borealis/layout-express";
import { i18n } from "@lingui/core";

export async function dynamicActivate(locale?: Locale) {
  const localeToLoadAndActivate: Locale = locale === "nb" ? "nb" : "en";

  const { messages } = await import(`../locales/${localeToLoadAndActivate}.mjs`);

  i18n.load(localeToLoadAndActivate, messages);
  i18n.activate(localeToLoadAndActivate);
}
